"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformSnakeCase = exports.uuid = void 0;
function uuid() {
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) => (Number(c) ^ (window.crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (Number(c) / 4)))).toString(16));
}
exports.uuid = uuid;
function transformSnakeCase(str) {
    return str.replace(/(_\w)/g, (m) => m[1].toUpperCase());
}
exports.transformSnakeCase = transformSnakeCase;
